module.exports = __webpack_public_path__ + "img/fire_main_mo.d06c2c45.jpg";